import { ResponsibilitiesResponseData } from 'src/api/common/lists/lists-api'
import { permissionAtom } from './permission-atom'

export function filterAllowedProcurements(procurements: Array<ResponsibilitiesResponseData>): Array<ResponsibilitiesResponseData> {
  const { allowedProcurementIdsSet } = permissionAtom.getState()

  return procurements
    .filter(({ name }) => allowedProcurementIdsSet.has(name)) // TODO:CLARIFY Is 'id' always equal to 'name'?
}
